// components/auth/RequireRole.js
import { useAuth } from "../../contexts/AuthContext";

// Dùng cho react-router v6+
// Sử dụng: <RequireRole roles={["teacher", "admin"]}><SomePage /></RequireRole>
export default function RequireRole({ roles = [], children }) {
  const { userExt, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center min-h-screen">Đang tải...</div>;

  // Lấy roles (ưu tiên mảng, fallback role string)
  const userRoles = userExt?.roles || (userExt?.role ? [userExt.role] : []);
  const hasRole = roles.length === 0 // Nếu không truyền roles, ai cũng vào được
    ? true
    : userRoles.some(r => roles.includes(r));

  if (!hasRole) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[50vh] text-red-600">
        <div className="text-3xl mb-4">🚫</div>
        <div className="text-lg font-semibold">Bạn không có quyền truy cập trang này.</div>
      </div>
    );
  }

  return children;
}
